var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 15.0833C4.16699 14.6231 4.54009 14.25 5.00033 14.25H10.8337C11.2939 14.25 11.667 14.6231 11.667 15.0833C11.667 15.5436 11.2939 15.9167 10.8337 15.9167H5.00033C4.54009 15.9167 4.16699 15.5436 4.16699 15.0833Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 14.25C12.8734 14.25 12.5003 14.6231 12.5003 15.0833C12.5003 15.5436 12.8734 15.9167 13.3337 15.9167H15.0003C15.4606 15.9167 15.8337 15.5436 15.8337 15.0833C15.8337 14.6231 15.4606 14.25 15.0003 14.25H13.3337Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 1.75C7.12723 1.75 7.50033 2.1231 7.50033 2.58333V3.41667H12.5003V2.58333C12.5003 2.1231 12.8734 1.75 13.3337 1.75C13.7939 1.75 14.167 2.1231 14.167 2.58333V3.41667H15.0003C16.8413 3.41667 18.3337 4.90905 18.3337 6.75V15.9167C18.3337 17.7576 16.8413 19.25 15.0003 19.25H5.00033C3.15938 19.25 1.66699 17.7576 1.66699 15.9167V6.75C1.66699 4.90905 3.15938 3.41667 5.00033 3.41667H5.83366V2.58333C5.83366 2.1231 6.20676 1.75 6.66699 1.75ZM12.5003 5.08333C12.5003 5.54357 12.8734 5.91667 13.3337 5.91667C13.7939 5.91667 14.167 5.54357 14.167 5.08333H15.0003C15.9208 5.08333 16.667 5.82953 16.667 6.75V7.16667H3.33366V6.75C3.33366 5.82953 4.07985 5.08333 5.00033 5.08333H5.83366C5.83366 5.54357 6.20676 5.91667 6.66699 5.91667C7.12723 5.91667 7.50033 5.54357 7.50033 5.08333H12.5003ZM16.667 8.83333H3.33366V15.9167C3.33366 16.8371 4.07985 17.5833 5.00033 17.5833H15.0003C15.9208 17.5833 16.667 16.8371 16.667 15.9167V8.83333Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.ff47025147aaba6e18d461191ae77834.svg";
export { ForwardRef as ReactComponent };